import { render, staticRenderFns } from "./CustomMaskedField.vue?vue&type=template&id=ca131af4&scoped=true"
import script from "./CustomMaskedField.vue?vue&type=script&lang=js"
export * from "./CustomMaskedField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca131af4",
  null
  
)

export default component.exports